import styled from 'styled-components'
import Tooltip from '.'

const TooltipObject = styled(Tooltip) `
    transform: translateY(-20px);
`

export default TooltipObject